import { back } from "../../../../helpers/dataServer";

export const API_PURCHASE_OK = `${back}/productos/sent`;
export const API_PURCHASE_NO = `${back}/productos/buy`;
